import React, { useContext, useState } from 'react'
import { useParams } from 'react-router';
import { getCompanyDetails } from '../../service/CompanyService';
import { getFeatureFlags } from '../../service/FeatureFlagService';

const CompanyContext = React.createContext()
const CompanyUpdateContext = React.createContext()
const CompanyPermissionContext = React.createContext()
const CompanyPermissionUpdateContext = React.createContext()
const CompanyFeatureFlagContext = React.createContext();

export function useCompany() {
    let company = useContext(CompanyContext);
    const { companyNumber } = useParams();
    if (companyNumber && !isNaN(companyNumber)) {
        if (company && !company.companyNumber) {
            company.companyNumber = companyNumber;
        } else if (!company) {
            company = { companyNumber };
        }
    }
    return company;
}

export function useCompanyUpdate() {
    return useContext(CompanyUpdateContext)
}

export function useCompanyPermission() {
    return useContext(CompanyPermissionContext)
}

export function useCompanyPermissionUpdate() {
    return useContext(CompanyPermissionUpdateContext)
}

export function useCompanyFeatureFlag() {
    return useContext(CompanyFeatureFlagContext);
}

export function CompanyProvider({ children }) {
    const [company, setCompany] = useState({})
    const [permissions, setPermissions] = useState([])
    const [featureFlags, setFeatureFlags] = useState([]);

    function handleData(flags) {
        setFeatureFlags(flags.features);
    }

    function changeCompany(company) {
        // Allow dependent service calls to start before all company info is returned,
        // setting temporary loading attribute to notify more is coming
        setCompany({ ...company, loadingDetails: true });

        getFeatureFlags(company.companyNumber, handleData);

        getCompanyDetails(company, setCompany);
    }

    return (
        <CompanyContext.Provider value={company}>
            <CompanyUpdateContext.Provider value={changeCompany}>
                <CompanyFeatureFlagContext.Provider value={featureFlags}>
                    <CompanyPermissionContext.Provider value={permissions}>
                        <CompanyPermissionUpdateContext.Provider value={setPermissions}>
                            {children}
                        </CompanyPermissionUpdateContext.Provider>
                    </CompanyPermissionContext.Provider>
                </CompanyFeatureFlagContext.Provider>
            </CompanyUpdateContext.Provider>
        </CompanyContext.Provider>
    )
}
